/**
 * Created by Marcus Zhao on 12/01/2020
 * -------------------------------------
 */

import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'tam-contact-msd',
    templateUrl: './contact-msd.component.html',
    styleUrls: ['./contact-msd.component.scss'],
    standalone: false
})
export class ContactMsdComponent implements OnInit {
    @Input() childConfig: any;
    constructor() { }

    ngOnInit() {
    }

}
